import { render } from "./UserAgreement.vue?vue&type=template&id=5d96461d"
const script = {}

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__